import * as React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Helmet } from 'react-helmet'

import { TopMenu } from './TopMenu'
import { Footer } from './Footer'

export const Layout = ({ children, topMenu, activeDocMeta }) => {
  const queryData = useStaticQuery(graphql`
    query SiteQuery {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `)

  return (
    <>
      <Helmet htmlAttributes={{ lang: activeDocMeta.lang }}>
        <meta charSet="utf-8" />
        <title>{queryData.site.siteMetadata.title}</title>
        <meta
          name="description"
          content={queryData.site.siteMetadata.description}
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link
          href="https://fonts.googleapis.com/css?family=Lato:300,400,700,900"
          rel="stylesheet"
          type="text/css"
        />
        <link
          href="https://fonts.googleapis.com/icon?family=Material+Icons"
          rel="stylesheet"
        />
        <link href="https://assets.juicer.io/embed.css" media="all" rel="stylesheet" type="text/css" />

        {activeDocMeta.alternateLanguages.map((altLang) => {
          return (
            <link rel="alternate" hrefLang={altLang.lang} href={linkResolver(altLang)} key={altLang.lang} />
          )
        })}
      </Helmet>
      <TopMenu topMenu={topMenu} activeDocMeta={activeDocMeta} />
      <main>{children}</main>
      <Footer siteMeta={queryData.site.siteMetadata}/>
    </>
  )
}
